import * as queries from "./actions/queries";

export let initialState = {
  fetching: false,
  fetched: false,
  userId: undefined,
  token: undefined,
  error: undefined,
};

const ssnBlock = (state = initialState, action = { type: "" }) => {
  switch (action.type) {
    case queries.GET_IM_TOKEN_REQUEST: {
      return Object.assign({}, state, { fetching: true });
    }

    case queries.GET_IM_TOKEN_SUCCESS: {
      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        token: action.response,
      });
    }

    case queries.GET_IM_TOKEN_ERROR: {
      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        error: action.error,
      });
    }

    default:
      return state;
  }
};

export default ssnBlock;
